import axiosInstanceApiGateway from 'config/apiServiceApiGateway'

export type ScheduleType = {
  all_day: boolean
  day: number
  open_time: string
  close_time: string
}

export type GetCloudKitchenScheduleProductHubResponseType = {
  data: {
    location_id: number
    product_id: number
    schedules: ScheduleType[]
  }
}

export type PostCloudKitchenScheduleProductHubPayloadType = {
  location_id: number
  product_id: number
  schedules: ScheduleType[]
}

export const getCloudKitchenScheduleProductHubAPI = (productId: number, locationId: number) =>
  axiosInstanceApiGateway.Get<GetCloudKitchenScheduleProductHubResponseType, true>({
    url: `/wims/internal/v1/kitchen-schedules/products/${productId}/locations/${locationId}`,
  })

export const postCloudKitchenScheduleProductHubAPI = (
  payload: PostCloudKitchenScheduleProductHubPayloadType,
) =>
  axiosInstanceApiGateway.Post<GetCloudKitchenScheduleProductHubResponseType>({
    url: `/wims/internal/v1/kitchen-schedules`,
    data: payload,
  })
